import React from 'react';
import EmptyState from '../common/EmptyState';

// The API returns `documents` as an object keyed by type, not an array, and a
// key is simply absent when no current document of that type exists.
const TYPES = [
  { key: 'cv', label: 'CV' },
  { key: 'cover_letter', label: 'Cover letter' },
  { key: 'personal_statement', label: 'Personal statement' },
];

const formatSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const StudentDocumentsPanel = ({ documents, loading, forbidden, error }) => {
  if (loading) return <p className="td-loading">Loading documents…</p>;

  // Under an ordinary instructor account the backend runs a real membership
  // join and returns 403 when the teacher does not share a school with the
  // student. That is an expected state, not a crash.
  if (forbidden) {
    return (
      <EmptyState
        tone="warning"
        title="You don't have access to this student's documents"
        body="Documents are visible only to teachers who share a group with the student."
      />
    );
  }
  if (error) return <EmptyState tone="warning" title="Could not load documents" body={error} />;

  const docs = documents || {};
  const present = TYPES.filter((t) => docs[t.key]);

  if (!present.length) {
    return <EmptyState title="No documents uploaded yet" body="The student has not uploaded a CV, cover letter or personal statement." />;
  }

  return (
    <ul className="td-doclist">
      {TYPES.map((t) => {
        const doc = docs[t.key];
        return (
          <li key={t.key} className={`td-doclist__row${doc ? '' : ' td-doclist__row--missing'}`}>
            <span className="td-doclist__type">{t.label}</span>
            {doc ? (
              <>
                <span className="td-doclist__name">{doc.original_filename || 'Untitled'}</span>
                <span className="td-doclist__meta">
                  {formatSize(doc.file_size)}
                  {doc.upload_date ? ` · ${String(doc.upload_date).slice(0, 10)}` : ''}
                </span>
                {doc.spaces_url ? (
                  <a className="td-btn td-btn--small" href={doc.spaces_url} target="_blank" rel="noopener noreferrer">
                    Open
                  </a>
                ) : null}
              </>
            ) : (
              <span className="td-doclist__missing">Not uploaded</span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default StudentDocumentsPanel;
